export { Hero, getStoriesData } from './Hero'
export { Faculties, getFacultiesData } from './Faculties'
export { Mission, getMissionData } from './Mission'
export { Testimonials } from './Testimonials'
export { Journal } from './Journal'
